module.exports = __webpack_public_path__ + "assets/img/gift-bg.3c556385.png";